import React from 'react';

import {Badge, HStack, Text, VStack} from "@chakra-ui/react";
import {format} from "date-fns";

import {useLanguage} from "@/contexts/languageContext";
import {Skeleton} from "@/components/ui";
import stringUtil from "@/utils/stringUtil";

export const EventBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        maxH="6rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { stringUtil.getRandomString(10, 25) }
                </Text>
            </Skeleton>
            <Skeleton>
                <Text
                    fontSize="sm"
                    isTruncated
                >
                    { stringUtil.getRandomString(20, 30) }
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const EventBody = ({element, ...props}) => {
    const {language, hourFormat, t} = useLanguage();

    return (
        <HStack
            gap="1vw"
            minH="3.5rem"
            maxH="6rem"
            color="secondary.500"
            overflow="hidden"
            {...props}
        >
            <VStack align="flex-start" flex={1} overflow="hidden">
                <HStack>
                    <Text
                        fontWeight="bold"
                        fontSize="md"
                        isTruncated
                        color="secondary.500"
                    >
                        {element[`${language}Title`]}
                    </Text>
                    {
                        element?.type === 'WEBINAR' &&
                        <Badge fontSize=".8em">{t('events.typeWebinar')}</Badge>
                    }
                </HStack>
                <Text
                    fontSize="sm"
                    color="secondary.500"
                    isTruncated
                >
                    {`${t('misc.from')} ${format(new Date(element?.startDate), `dd/MM/yyyy ${hourFormat}`)} ${t('misc.to')} ${format(new Date(element?.endDate), `dd/MM/yyyy ${hourFormat}`)}`}
                </Text>
            </VStack>
        </HStack>
    );
};

export default EventBody;
